<template>
  <div class="app-container">
    <el-card shadow="hover">
      <!-- 查询和其他操作 -->
      <div class="filter-container">
        <el-input v-model="listQuery.name" clearable class="filter-item" style="width: 200px;" placeholder="请输入标签名称" />

        <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
        <el-button class="filter-item" type="primary" icon="el-icon-edit" @click="handleCreate(null)">添加</el-button>
      </div>

      <!-- 查询结果 -->
      <el-table v-loading="listLoading" :data="list" element-loading-text="正在查询中。。。" border fit highlight-current-row
        row-key="id">

        <el-table-column align="left" label="标签名称" prop="name" width="300px" />


        <el-table-column align="center" label="标签预估对应人数" prop="amount" />

        <el-table-column align="center" label="状态" prop="deleted">
          <template slot-scope="scope">
            <el-tag :type="scope.row.deleted ? 'success' : 'error'">{{ scope.row.deleted ? '不启用' : '启用' }}</el-tag>
          </template>
        </el-table-column>

        <el-table-column align="center" label="备注" prop="remark" show-overflow-tooltip />

        <el-table-column align="center" label="操作" width="300" class-name="small-padding fixed-width">
          <template slot-scope="scope">
            <el-button v-show="scope.row.level != 2" icon="el-icon-plus" type="text" size="mini"
              @click="handleCreate(scope.row)">新增下一级</el-button>
            <el-button icon="el-icon-edit" type="text" size="mini" @click="handleUpdate(scope.row)">编辑</el-button>
            <el-button style="color:red" icon="el-icon-close" type="text" size="mini"
              @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
        @pagination="getList" />

      <!-- 添加或修改对话框 -->
      <el-dialog :title="textMap[dialogStatus]" :visible.sync="dialogFormVisible" width="750px">
        <el-form ref="dataForm" :rules="rules" :model="dataForm" status-icon label-position="left" label-width="120px"
          style="width: 600px; margin-left:50px;">
          <el-form-item label="上级标签名称" v-show="dataForm.parentName != null" prop="parentName">
            <span style="color:#09afff">{{ dataForm.parentName }}</span>
          </el-form-item>

          <el-form-item label="标签名称" prop="labelName">
            <el-input v-model="dataForm.labelName" placeholder="标签名称" />
          </el-form-item>

          <el-form-item v-show="dataForm.labelLevel === 2" label="执行频率" prop="labelFrequency">
            <el-radio-group v-model="dataForm.labelFrequency">
              <el-radio v-for="item in frequencyOptions" :key="item.value" :label="item.value" :value="item.value">{{
                item.label
              }}</el-radio>
            </el-radio-group>
          </el-form-item>

          <!-- <el-form-item v-show="dataForm.labelLevel === 2" label="对应企微标签" prop="cpTagValue">
            <el-cascader placeholder="请选择对应的企微标签" style="width: 100%" v-model="cpTagValue" :options="cpTagList" :props="{
              expandTrigger: 'hover',
              value: 'id',
              label: 'name',
              multiple: false,
            }" @change="cascaderChange" clearable :show-all-levels="true" size="mini"></el-cascader>
          </el-form-item> -->

          <el-form-item v-show="dataForm.labelLevel === 2" label="标签SQL" prop="labelSql">
            <el-input v-model="dataForm.labelSql" rows="8"
              placeholder="符合标签的sql语句 如：select worker_no,label from customer_client" type="textarea" />
          </el-form-item>

          <el-form-item v-show="dataForm.labelLevel === 2" label="标签属性" prop="labelProperty">
            <el-radio-group v-model="dataForm.labelProperty">
              <el-radio label="string">字符串</el-radio>
              <el-radio label="int">数值</el-radio>
              <!-- <el-radio label="percent">百分比</el-radio> -->
              <el-radio label="date">日期</el-radio>
              <!-- <el-radio label="boolean">是否</el-radio> -->
              <el-radio label="enum">枚举</el-radio>
            </el-radio-group>
          </el-form-item>

          <el-form-item v-show="dataForm.labelProperty === 'enum' && dataForm.labelLevel === 2" label="标签枚举值"
            prop="labelValue">
            <el-tag v-for="tag in keywords" :key="tag" closable type="primary" @close="handleClose(tag)">
              {{ tag }}
            </el-tag>
            <el-input v-if="newKeywordVisible" ref="newKeywordInput" style="width:100px" v-model="newKeyword"
              class="input-new-keyword" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm" />
            <el-button v-else class="button-new-keyword" type="primary" @click="showInput" size="mini">+ 增加</el-button>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input v-model="dataForm.remark" />
          </el-form-item>

        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取消</el-button>
          <el-button v-if="dialogStatus == 'create'" type="primary" @click="createData">确定</el-button>
          <el-button v-else type="primary" @click="updateData">修改</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>


<script>
import service from "@/script/api/workercrmapi";
import Pagination from "@/components/common/Pagination";

const defaultFrequencyOptions = [
  {
    label: "每日一次",
    value: 0,
  },
  // {
  //   label: "每10分钟一次",
  //   value: 1,
  // },
];

export default {
  name: "LabelSetting",
  components: { Pagination },
  filters: {
  },
  data() {
    const validateFrequency = (rule, value, callback) => {
      if (this.dataForm.labelLevel == 2 && value === null) {
        callback(new Error("请选择执行频次"));
      } else {
        callback();
      }
    };
    const validateSql = (rule, value, callback) => {
      if (
        this.dataForm.labelLevel == 2 &&
        (value == "" || value == undefined || value == null)
      ) {
        callback(new Error("请输入标签SQL"));
      } else {
        callback();
      }
    };
    const validateProperty = (rule, value, callback) => {
      if (this.dataForm.labelLevel == 2 &&
        (value == "" || value == undefined || value == null)
      ) {
        callback(new Error("请选择标签属性"));
      } else {
        callback();
      }
    };
    return {
      frequencyOptions: Object.assign({}, defaultFrequencyOptions),
      cpTagList: [],//企微标签
      cpTagValue: '',
      list: [],
      keywords: [], //枚举值集合
      newKeywordVisible: false,
      newKeyword: "",
      total: 0,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        name: undefined,
        labelType: undefined,
        deleted: undefined,
        sort: "create_time",
        order: "desc",
      },
      dataForm: {
        id: undefined,
        labelLevel: 0,
        labelValueStart: undefined,
        labelValueEnd: undefined,
        cpTagId: '',
        deleted: false,
        labelName: undefined,
        labelValue: undefined,
        labelProperty: undefined,
        labelSql: undefined,
        parentName: "一级标签",
      },
      dialogFormVisible: false,
      dialogStatus: "",
      textMap: {
        update: "编辑标签",
        create: "创建标签",
      },
      rules: {
        labelFrequency: [
          {
            validator: validateFrequency,
            required: true,
            message: "请选择执行频次",
            trigger: "blur",
          },
        ],
        labelName: [
          { required: true, message: "标签标题不能为空", trigger: "blur" },
        ],
        labelProperty: [
          {
            validator: validateProperty,
            required: true,
            message: "列属性不能为空",
            trigger: "blur",
          },
        ],
        labelSql: [{ validator: validateSql, required: true, trigger: "blur" }],
      },
      downloadLoading: false,
    };
  },
  created() {
    this.getList(); 
  },
  methods: {
    getList() {
      this.listLoading = true;
      service
        .$axiosWorkerLabelList(this.listQuery)
        .then((response) => {
          this.list = response.data.data;
          //console.info(this.list);
          //this.total = response.data.data.total
          this.listLoading = false;
        })
        .catch(() => {
          this.list = [];
          this.listLoading = false;
        });
    },
    getTagList() {
      service.$axiosCpTagList().then(res => {
        this.cpTagList = res.data.data;
      })
    },
    cascaderChange(value) {
      console.info(this.cpTagValue);
      this.cpTagValue = value;
    },
    handleCategoryChange(value) {
      this.dataForm.labelCategory = value[value.length - 1];
    },
    handleTypeChange(value) {
      console.info(value);
      if (value == 1) {
        this.dataForm.labelProperty = "string";
        this.dataForm.labelSql = "";
      }
    },
    handleClose(tag) {
      this.keywords.splice(this.keywords.indexOf(tag), 1);
      this.dataForm.labelValue = this.keywords.toString();
    },
    showInput() {
      this.newKeywordVisible = true;
      this.$nextTick((_) => {
        this.$refs.newKeywordInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      const newKeyword = this.newKeyword;
      if (newKeyword) {
        this.keywords.push(newKeyword);
        this.dataForm.labelValue = this.keywords.toString();
      }
      this.newKeywordVisible = false;
      this.newKeyword = "";
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    resetForm() {
      this.dataForm = {
        id: undefined,
        labelLevel: 0,
        labelName: undefined,
        labelValue: undefined,
        deleted: false,
        labelProperty: 0,
        parentName: "一级标签",
        labelSql: undefined,
        labelFrequency: 0,
        cpTagId: ''
      };
      this.keywords = [];
      this.cpTagValue = '';
    },
    handleCreate(row) {
      this.resetForm();
      if (row != null) {
        console.info("row!=null");
        this.dataForm.labelLevel = row.level + 1;
        this.dataForm.labelFrequency = 0;
        this.dataForm.labelParentId = row.id;
        this.dataForm.parentName = row.name;
      }
      console.info(this.dataForm);
      this.dialogStatus = "create";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });
    },
    createData() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          if (this.cpTagValue && this.cpTagValue.length > 0)
            this.dataForm.cpTagId = this.cpTagValue[1];

          service
            .$axiosWorkerLabelCreate(this.dataForm)
            .then((response) => {
              this.getList();
              this.dialogFormVisible = false;
              this.$notify.success({
                title: "成功",
                message: "创建标签成功，数据筛选大约在10分钟后完成",
              });
            })
            .catch((response) => {
              this.$notify.error({
                title: "失败",
                message: response.data.errmsg,
              });
            });
        }
      });
    },
    handleUpdate(row) {
      console.info(row);
      this.dataForm = {
        id: row.id,
        labelLevel: row.level,
        labelName: row.name,
        labelValue: row.value,
        labelSql: row.sql,
        labelProperty: row.property,
        labelFrequency: row.frequency == null ? 0 : row.frequency,
        remark: row.remark
      };
      this.dialogStatus = "update";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs["dataForm"].clearValidate();
      });

      this.keywords = row.value == null ? [] : row.value.split(",");
    },
    updateData() {
      console.info('updateData')
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          service
            .$axiosWorkerLabelUpdate(this.dataForm)
            .then(() => {
              this.getList();
              this.dialogFormVisible = false;
              this.$notify.success({
                title: "成功",
                message: "更新成功",
              });
            })
            .catch((response) => {
              this.$notify.error({
                title: "失败",
                message: response.data.errmsg,
              });
            });
        }
      });
    },
    handleDelete(row) {
      service
        .$axiosWorkerLabelDelete(row)
        .then((response) => {
          this.$notify.success({
            title: "成功",
            message: "停用标签成功",
          });

          this.getList();
        })
        .catch((response) => {
          this.$notify.error({
            title: "失败",
            message: response.data.errmsg,
          });
        });
    },
  },
};
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #20a0ff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

.el-button--text {
  padding: 0 !important;
  width: auto !important;
  margin-left: 5px !important;
}

.el-button--text span {
  margin-left: 0px !important;
}
</style>